import Actions from 'flow/actions';
import OperatorResource from 'flow/api/operator';
import { networkErrorDispatcher } from 'flow/actions/app-actions';

export const fetchOperators = () => (dispatch) => {
    OperatorResource.getOperators({
        onResult(json) {
            dispatch(receiveOperators(json));
        },
        onError: networkErrorDispatcher(dispatch),
    });
};

export const fetchOperatorData = (operatorKey) => (dispatch) => {
    OperatorResource.getOperator(
        {
            onResult(json) {
                dispatch(receiveOperatorData(json));
            },
            onError: networkErrorDispatcher(dispatch),
        },
        operatorKey,
    );
};

const receiveOperators = (operators) => (dispatch) => {
    dispatch({
        type: Actions.RESULT_OPERATOR_OPERATORS,
        operators,
    });
};

const receiveOperatorData =
    (data = {}) =>
    (dispatch) => {
        dispatch({
            type: Actions.RESULT_OPERATOR_DATA,
            data,
        });
    };
